import './App.css';
import GeneratorContainer from './components/GeneratorContainer';

function App() {
  return (
    <div className="App">
      <GeneratorContainer></GeneratorContainer>
    </div>
  );
}

export default App;
